import React from 'react';

type WithAdaptiveOptions = {
  displayName?: string;
  ssrClassName?: string;
};
interface AdaptiveProps {
  children: React.ReactNode;
}

export const createAdaptiveComponent = ({ displayName, ssrClassName }: WithAdaptiveOptions) => {
  const AdaptiveComponent: React.FC<AdaptiveProps> = ({ children }) => (
    <div className={ssrClassName}>{children}</div>
  );

  if (process.env.NODE_ENV !== 'production') {
    AdaptiveComponent.displayName = displayName;
  }

  return AdaptiveComponent;
};
